import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatsInsideSection() {
  const items = [{
    title: 'The First 120 Seconds Script',
    desc: 'exact words to stop sleep math + panic escalation'
  }, {
    title: 'The Body Alarm Protocol',
    desc: 'downshift without turning it into a huge event'
  }, {
    title: 'The Thought Spiral Protocol',
    desc: 'exit the mental negotiation without "fighting thoughts"'
  }, {
    title: 'The Bed Fear Protocol',
    desc: 'decondition the "bed = performance" pattern'
  }, {
    title: 'The Gentle Exit Plan',
    desc: 'what to do when staying in bed is making it worse'
  }, {
    title: 'A printable 3AM Card',
    desc: 'to keep by your bed'
  }, {
    title: 'A simple 7-day tracker',
    desc: "so you can see what's improving (without obsessing)"
  }];
  return <section className="py-14 md:py-24 px-5 md:px-6 bg-[#0a0e1a]" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="mb-8 md:mb-12" data-id="element-160">
          <h2 className="text-2xl md:text-4xl font-playfair text-[#f5f0e8] mb-3 md:mb-4" data-id="element-161">
            What you get
            <span className="block text-base md:text-xl text-[#8b8178] mt-1 md:mt-2 font-sans font-light" data-id="element-162">
              (what's inside the PDF)
            </span>
          </h2>
          <p className="text-lg md:text-xl text-[#e8e0d4] mt-4 md:mt-6" data-id="element-163">
            <strong className="text-[#c9a96e]" data-id="element-164">A 7-day reset plan</strong>{' '}
            designed to be used by real adults with real stress.
          </p>
        </motion.div>

        <div className="space-y-4 md:space-y-6" data-id="element-165">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.6
        }} className="flex items-start group" data-id="element-166">
              <div className="flex-shrink-0 mt-0.5 mr-3 md:mr-4" data-id="element-167">
                <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#c9a96e]/20 flex items-center justify-center" data-id="element-168">
                  <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#c9a96e]" data-id="element-169" />
                </div>
              </div>
              <div data-id="element-170">
                <h3 className="text-base md:text-lg font-bold text-[#f5f0e8]" data-id="element-171">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-[#8b8178]" data-id="element-172">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="mt-10 md:mt-16 pt-6 md:pt-8 border-t border-[#ffffff]/10 text-center" data-id="element-173">
          <p className="text-lg md:text-xl font-playfair italic text-[#e8e0d4] mb-6 md:mb-8" data-id="element-174">
            No fluff. No 40-page bedtime routine.
            <br data-id="element-175" />
            Just a calm plan for the exact moment your night starts slipping.
          </p>

          <a href="#checkout" className="inline-block bg-[#c9a96e] hover:bg-[#d4b87a] text-[#0a0e1a] px-6 py-3 md:px-8 md:py-4 rounded-full font-bold text-base md:text-lg transition-all duration-300 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)]" data-id="element-176">
            Get The 3AM Loop Breaker
          </a>
        </motion.div>
      </div>
    </section>;
}